import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from 'lucide-react';

function Nav() {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <nav className="bg-gradient-to-r from-violet-500 to-red-500 text-transparent bg-clip-text p-4 relative">
            <div className="flex justify-between items-center">
                <h1 className="text-xl font-bold">Unito</h1>

                {/* Desktop Links */}
                <ul className="hidden md:flex space-x-4">
                    <li><Link to="/" className="text-red hover:text-gray-600">Home</Link></li>
                    <li><a href="/problems" className="text-red hover:text-gray-600">Problems</a></li>
                    <li><Link to="/chat" className="text-red hover:text-gray-600">AI Coach</Link></li>
                    <li><a href="/profile" className="text-red hover:text-gray-600">Profile stats</a></li>
                    <li><Link to="/register" className="text-red hover:text-gray-600">Log in</Link></li>
                </ul>

                {/* Mobile Menu Button */}
                <div className="block md:hidden">
                    <button onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? <X className="w-6 h-6 text-white" /> : <Menu className="w-6 h-6 text-white" />}
                    </button>
                </div>
            </div>

            {/* Mobile Dropdown */}
            {isOpen && (
                <ul className="md:hidden absolute bg-gradient-to-r from-violet-300 to-red-300 text-black items-center text-center top-full left-0 w-full shadow-md py-4 px-6 space-y-3 z-50">
                    <li><a href="/" className="block text-red hover:text-gray-600">Home</a></li>
                    <li><a href="/problems" className="block text-red hover:text-gray-600">Problems</a></li>
                    <li><a href="/chat" className="block text-red hover:text-gray-600">AI Coach</a></li>
                    <li><a href="/profile" className="block text-red hover:text-gray-600">Profile stats</a></li>
                    <li><a href="/register" className="block text-red hover:text-gray-600">Log in</a></li>
                </ul>
            )}
        </nav>
    );
}

export default Nav;
